import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Skeleton } from '@material-ui/lab';

const DocumentListSkeleton = () => {
  return (
    <>
      <Skeleton />
      <Skeleton />
      <Skeleton />
      <Skeleton />
      <Skeleton />
    </>
  );
};


DocumentListSkeleton.defaultProps = {};

DocumentListSkeleton.propTypes = {};

export default withStyles({})(DocumentListSkeleton);
